import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as React from 'react';

const DashboardWarningIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 16 17" sx={{ height: '17px', width: '16px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M7.99982 6.50015V9.16682M7.99982 11.8335H8.00648M7.0767 3.09464L1.59344 12.5657C1.2893 13.091 1.13723 13.3537 1.15971 13.5693C1.17931 13.7573 1.27783 13.9282 1.43073 14.0394C1.60604 14.1668 1.90954 14.1668 2.51656 14.1668H13.4831C14.0901 14.1668 14.3936 14.1668 14.5689 14.0394C14.7218 13.9282 14.8203 13.7573 14.8399 13.5693C14.8624 13.3537 14.7103 13.091 14.4062 12.5657L8.92294 3.09463C8.61989 2.57119 8.46837 2.30947 8.27068 2.22157C8.09824 2.14489 7.90139 2.14489 7.72895 2.22157C7.53126 2.30947 7.37974 2.57119 7.0767 3.09464Z"
        stroke="#FF5F57"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default DashboardWarningIcon;
